import { useRef } from "react";
import { useForm } from "react-hook-form";

const PwdModal = ({ closeModal, onChangeHandler, changePwd, pwdErrorMsg }) => {
  // react hook form
  const {
    handleSubmit,
    register,
    watch,
    formState: { errors },
  } = useForm({ mode: "onChange" });
  const newWords = useRef({});
  newWords.current = watch("newWords", "");

  return (
    <div className="popup_bg_bbs " onClick={closeModal}>
      <div className="password_change " onClick={(e) => e.stopPropagation()}>
        <div className="pophead_bbs">
          <h1>비밀번호 변경</h1>
        </div>
        <div className="password_change_inner">
          <div className="input_wrap ">
            <input
              className="input_box"
              type="password"
              name="oldKey"
              placeholder="기존비밀번호"
              {...register("oldWords", {
                onChange: onChangeHandler,
                required: "* 기존 비밀번호는 필수 입력입니다.",
              })}
            />
          </div>
          <div className="error_msg">
            {errors.oldWords && <p>{errors.oldWords?.message}</p>}
          </div>
          <div className="input_wrap">
            <input
              className="input_box"
              type="password"
              name="newWords"
              placeholder="변경할 비밀번호"
              {...register("newWords", {
                onChange: onChangeHandler,
                required: "* 변경할 비밀번호는 필수 입력입니다.",
                pattern: {
                  value:
                    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,16}$/,
                  message:
                    "* 비밀번호는 숫자와 영문대,소문자,특수문자 조합의 8자리 이상 16자리이하 구성입니다.",
                },
              })}
            />
          </div>
          <div className="error_msg">
            {errors.newWords && <p>{errors.newWords?.message}</p>}
          </div>
          <div className="input_wrap">
            <input
              className="input_box"
              type="password"
              name="checkNewWords"
              placeholder="변경할 비밀번호 확인"
              {...register("checkNewWords", {
                onChange: onChangeHandler,
                required: "* 변경할 비밀번호 확인은 필수 입력입니다.",
                pattern: {
                  value:
                    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,16}$/,
                  message:
                    "* 비밀번호는 숫자와 영문대,소문자,특수문자 조합의 8자리 이상 16자리이하 구성입니다.",
                },
                validate: (value) =>
                  value === newWords.current ||
                  "* 변경할 비밀번호가 일치하지 않습니다.",
              })}
            />
          </div>
          <div className="error_msg">
            {errors.checkNewWords && <p>{errors.checkNewWords?.message}</p>}
          </div>
          {pwdErrorMsg ? (
            <div className="error_msg">
              * 비밀번호를 변경할 수 없습니다. 입력하신 정보를 확인해 주십시오.
            </div>
          ) : null}
          <div className="btns_wrap">
            <button className="btn_lor" onClick={closeModal}>
              <span className="material-icons">취소</span>
            </button>
            <button className="btn_color" onClick={changePwd}>
              <span className="material-icons">변경</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default PwdModal;
